import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import SortableReturnInstructionListSkeleton from './SortableReturnInstructionListSkeleton/SortableReturnInstructionListSkeleton'
import SortableReturnInstruction from './SortableReturnInstruction'

const SortableReturnInstructionList = ({
  returnInstructions,
  onEdit,
  onDuplicate,
  onDelete,
  onSortStart,
  onSortEnd,
  loading,
  isEditable,
}) => {
  const sensors = useSensors(useSensor(PointerSensor))

  if (loading) {
    return <SortableReturnInstructionListSkeleton />
  }

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSortEnd} onDragStart={onSortStart}>
      <SortableContext items={returnInstructions} strategy={verticalListSortingStrategy}>
        <div>
          {returnInstructions.map((instruction, index) => (
            <SortableReturnInstruction
              key={instruction.id}
              data={instruction}
              index={index}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
              isEditable={isEditable}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  )
}

export default SortableReturnInstructionList
